<template>
  <div class="wrapper">
    <div class="detail">
      <!-- 我的积分 -->
      <div class="jfBox">
        <div class="jf">
          <p class="titleCom">总阳光积分</p>
          <!-- 后期替换积分图片 -->
          <img class="jfIcon" src="../../assets/images/mt//mt-h.png" alt />
          <p class="amount">{{userInfo.point||0}}</p>
          <p class="why" @click="goDesc">
            <i class="el-icon-question" ></i>
            什么是阳光积分
          </p>
        </div>
        <div class="rinkBox">
          <p class="titleCom">阳光积分排行榜</p>

          <router-link tag="i" class="el-icon-right " to="/center/pointlist"> </router-link>
          <ul class="rinkList">
            <li v-for="(item, index) in rinkList" :key="index">
              <p
                class="grade"
                :class="[index == 0 ? 'color1' : '', index == 1 ? 'color2' : '', index == 2 ? 'color3' : '']"
              >{{ item.rownum }}</p>
              <div>
                <img class="headImg" :src="item.avatar" alt />
                <div>
                  <p class="nickName">{{ item.nickname || '' }}</p>
                  <p class="vipDesc">{{ item.grade_name || '普通会员' }}</p>
                </div>
              </div>
              <p
                :class="[index == 0 ? 'color1' : '', index == 1 ? 'color2' : '', index == 2 ? 'color3' : '']"
              >{{ item.point }}</p>
            </li>
          </ul>
        </div>
      </div>
      <!-- 积分明细 -->
      <div class="displayBet">
        <div class="detail-title">
          <div class="titleCom">阳光积分明细</div>
        </div>
        <a href="https://km.sankuai.com/page/1304118096" target="_blank">
          <i class="el-icon-question"></i>
         阳光积分规则说明
        </a>
      </div>
      <el-table
        :data="pointList"
        style="width: 100%"
        v-if="pointList.length > 0"
        @filter-change="filterChange"
      >
        <el-table-column
          prop="ctime"
          label="时间"
          width="200"
          align="center"
          :filters="timeSelect"
          :filter-multiple="false"
        ></el-table-column>
        <el-table-column
          prop="num"
          label="积分"
          width="100"
          align="center"
          :filters="jfSelect"
          :filter-multiple="false"
        ></el-table-column>
        <el-table-column prop="remarks" label="积分说明" align="center"></el-table-column>
        <!-- <el-table-column prop="remarks" label="说明" align="center"></el-table-column> -->
        <el-table-column prop="balance" label="可用积分" align="center"></el-table-column>
      </el-table>
      <div v-else class="detail-nodata">您还没有任何积分明细记录哦~</div>
    </div>
    <div v-if="pointList.length > 0">
      <Pagination :totalPage="totalPage" :limit="limit" @changePage="handOrderMore"></Pagination>
    </div>
    <!-- 赚积分 -->
    <div class="titleCom">赚阳光积分</div>
    <div class="jfImg" v-if="advertList.length > 0">
      <a
        v-for="(item, index) in advertList"
        :key="index"
        @click="swiperClick(item)"
      >
        <img :src="item.img" alt />
      </a>

      <!-- <a href="http://" target="_blank" rel="noopener noreferrer">
        <img src="../../assets/images/cont-bg.jpg" alt />
      </a>
      <a href="http://" target="_blank" rel="noopener noreferrer">
        <img src="../../assets/images/cont-bg.jpg" alt />
      </a>
      <a href="http://" target="_blank" rel="noopener noreferrer">
        <img src="../../assets/images/cont-bg.jpg" alt />
      </a>
      <a href="http://" target="_blank" rel="noopener noreferrer">
        <img src="../../assets/images/cont-bg.jpg" alt />
      </a> -->
    </div>
  </div>
</template>

<script>
import { showLoading, hideLoading } from "../../utils/loading";
import { pointDescUrl } from "../../config/env.js";
import Pagination from "@/components/common/Pagination.vue";
import { isSafeRedirect } from "@/utils";
export default {
  name: "Point",
  components: { Pagination },
  props: {},
  data() {
    return {
      page: 1,
      limit: 5,
      totalPage: 1,
      where: {},
      pointList: [],
      advertList: [],
      rinkList: [], // 积分记录
      timeSelect: [
        { text: "最近一个月", value: "one" },
        { text: "最近三个月", value: "three" }
      ],
      jfSelect: [
        { text: "获取", value: "1" },
        { text: "使用", value: "-1" }
      ],
	  userInfo:{}
    };
  },
  created() {},
  mounted() {
    this.getPointLog();
    this.getPointRanking();
    this.advert();
    var date = new Date();
    var year = date.getFullYear();
    this.timeSelect.push({
      text: year + "年",
      value: "year"
    });
	this.getUserInfo();
  },
  watch: {},
  computed: {},
  methods: {
	goDesc(){
		const strUrl = pointDescUrl;
		let a = document.createElement("a");
		document.body.appendChild(a);
		a.style = "display: none";
		a.target = "_blank";
		a.href = strUrl;
		a.click();
		document.body.removeChild(a);
		//window.location.href=pointDescUrl;
	},
	getUserInfo() {
		this.$api.userInfo().then(result => {
			if (result.status) {
				this.userInfo = result.data;
				console.log(this.userInfo );
			}
		});
	},
    filterChange(column) {
      console.log(column);
      if (column.hasOwnProperty("el-table_1_column_1")) {
        this.where.date_string = column["el-table_1_column_1"][0];
        this.page = 1;
        this.getPointLog();
      } else if (column.hasOwnProperty("el-table_1_column_2")) {
        this.where.point_type_string = column["el-table_1_column_2"][0];
        this.page = 1;
        this.getPointLog();
      }
    },

    getPointRanking() {
      let data = {
        page: 1,
        limit: 5
      };
      this.$api.getPointRanking(data).then(res => {
        console.log("point", res);
        this.rinkList = res.data.list;
      });
    },
    getPointLog() {
      let data = {
        page: this.page,
        limit: this.limit,
        where: this.where
      };
      showLoading();
      this.$api.pointLog(data).then(res => {
        if (res.status) {
          this.totalPage = res.total;
          this.pointList = res.data;
          console.log(this.pointList);
        }
        hideLoading();
      });
    },
    handOrderMore(val) {
      this.page = val;
      this.getPointLog();
    },
    // /点击
    swiperClick(v) {
      // type 1 url 直接跳转
      // 2 商品
      //  3 文章
      // 4  文章分类
      // 5 智能表单
      this.$api.addRecord({
        type: "5",
        api_method: "advert.getcarousellists",
        platform: "1",
        code: v.code,
        rel_id: v.id
      });
      if (v.type == 1 && v.val!='#') {
        if (isSafeRedirect(v.val)) {
          window.open(v.val, "_blank");
        }
        return;
      }

      if (v.type == 2) {
        this.$router.push({
          path: `detail/${v.val}`
        });
        return;
      }
    },
    advert() {
      let _this = this;
      this.$api.advert({ codes: "member_point" }).then(res => {
        _this.advertList = res.data.list["member_point"] || [];
        console.log(_this.advertList);
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/variable.scss";
.wrapper {
  .detail {
    margin-bottom: 10px;
    &-title {
      color: #757575;
      line-height: 30px;
      margin-top: 10px;
      font-weight: 550;
      border-bottom: 1px solid $border;
    }
    &-nodata {
      margin: 30px auto;
      text-align: center;
    }
  }
}
.jfBox {
  display: flex;
}
.jf {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 26px 30px;
  flex: 1;
  border-right: 1px solid #efefef;
  .jfIcon {
    width: 40px;
    height: 40px;
    margin: 30px 0 10px;
  }
  .amount {
    font-size: 60px;
    margin-bottom: 50px;
  }
  .why {
  }
}
.titleCom {
  /* color: #0d0303; */
  font-weight: 500;
  font-size: 22px;
}
.el-icon-question {
  color: #ffc300;
}
.rinkBox {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 18px;
  padding: 26px 30px;
  // background-color: #FAFAFA;
  box-sizing: border-box;
  position: relative;
  .el-icon-right {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 28px;
    cursor: pointer;
  }
  .rinkList {
    color: #1a1a1a;
    font-size: 22px;
    > li {
      display: flex;
      align-items: center;
      margin-top: 10px;
      .grade {
        font-weight: 500;
      }
      > div {
        display: flex;
        align-items: center;
        width: 220px;
        padding-right: 10px;
        font-size: 14px;
      }
      .headImg {
        width: 40px;
        height: 40px;
        margin-right: 8px;
        margin-left: 20px;
        border-radius: 50%;
      }
      .nickName {
        font-weight: 300;
      }
      .vipDesc {
        color: #afafaf;
        font-size: 12px;
        margin-top: 6px;
      }
      .color1 {
        color: #fe4706;
      }
      .color2 {
        color: #fe8d4b;
      }
      .color3 {
        color: #fec200;
      }
    }
  }
}
// 赚积分
.jfImg {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 20px;
  > a {
    font-size: 22px;
    margin-bottom: 15px;
    > img {
      width: 450px;
      height: 156px;
    }
  }
}
</style>
